"use client"

import Link from "next/link"

export default function PreviewMessage() {
  const isEmbedded =
    typeof window !== "undefined" && window.location !== window.parent.location
  if (isEmbedded) {
    return null
  }
  return (
    <div
      style={{
        borderRadius: 14,
        color: "red",
        background: "black",
        textAlign: "center",
      }}
    >
      <Link href="/api/exit-preview" prefetch={false}>
        Exit Preview Mode
      </Link>
    </div>
  )
}
